import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export default api;

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) return err.message || "Algo ha salido mal";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map(e => (e?.msg ? e.msg : JSON.stringify(e))).join(", ");
  }
  return String(detail);
}

export function formatPrice(n) {
  if (typeof n !== "number") return "";
  return new Intl.NumberFormat("es-ES", { style: "currency", currency: "EUR" }).format(n);
}
